import { render, staticRenderFns } from "./SchedaMorteCodificaGemoComponent.vue?vue&type=template&id=464fd8ab"
import script from "./SchedaMorteCodificaGemoComponent.vue?vue&type=script&lang=js"
export * from "./SchedaMorteCodificaGemoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports